import { createContext, useState } from 'react';

export const InvestmentContext = createContext();

const INVESTMENT_KEY = 'investmentInitial';

export const InvestmentContextProvider = ({ children }) => {
  const [send, setSend] = useState(false);

  //Aquí lo tomo desde el localStorage:
  const [formData, setFormData] = useState(() => {
    try {
      const savedData = localStorage.getItem(INVESTMENT_KEY);
      return savedData ? JSON.parse(savedData) : {};
    } catch (e) {
      console.error('Error parsing localStorage initial', e);
      return {};
    }
  });
  const [dataSimulation, setDataSimulation] = useState({});
  const [dataSimulationResult, setDataSimulationResult] = useState([]);

  //guardo en el localStorage
  const setItemAsync = async (key, value) => {
    return new Promise(resolve => {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.error('Error saving to localStorage', e);
      }
      resolve();
    });
  };

  const removeItemAsync = async key => {
    return new Promise(resolve => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        console.error('Error removing localStorage key', e);
      }
      resolve();
    });
  };

  const setFormDataAndPersist = async values => {
    try {
      const storeObj = {
        initialInvestment: values.initialInvestment ?? '',
        monthlyInvestment: values.monthlyInvestment ?? '',
        months: values.months ?? '1 año',
      };
      await setItemAsync(INVESTMENT_KEY, JSON.stringify(storeObj)); //al refrescar los valores del formulario se caguen del local
      setFormData(storeObj); //actualizo desde el contexto
    } catch (e) {
      console.error('Error en setFormDataAndPersist', e);
    }
  };

  const resetFormData = () => {
    setFormData({});
    setDataSimulation({});
    setSend(false);
    setDataSimulationResult([]);
  };

  const clearStorage = async () => {
    await removeItemAsync(INVESTMENT_KEY);
  };

  return (
    <InvestmentContext.Provider
      value={{
        send,
        setSend,
        dataSimulation,
        setDataSimulation,
        formData,
        setFormData,
        setFormDataAndPersist,
        resetFormData,
        dataSimulationResult,
        setDataSimulationResult,
        clearStorage,
      }}>
      {children}
    </InvestmentContext.Provider>
  );
};
